module.exports = __webpack_public_path__ + "static/alpine-fleet-skin-35a88af6fa19df0897dc2514aac47777.jpg";